<div *ngIf="is_Loading" class="modal-body text-center py-5">
    <div class="mb-3">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <h5 class="mb-1">Sertifikanız hazırlanıyor</h5>
    <p class="text-muted mb-0">Lütfen bekleyiniz...</p>
</div>

<div *ngIf="!is_Loading">
    <div class="modal-header">
        <h4 class="modal-title">
            {{data.certificateNo}} No'lu Sertfika Revize Et
        </h4>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <p>Revize sertfika kaydedilsin mi?</p>
    </div>

    <div class="modal-footer d-flex justify-content-center gap-2">
        <button type="button" class="btn btn-outline-info" rippleEffect (click)="saveData(false)">
            <span [data-feather]="'eye'" [class]="'mr-25'"></span>
            Önizle
        </button>

        <button type="button" class="btn btn-outline-success" rippleEffect (click)="saveData(true)" [disabled]="isSaving">
            <span [data-feather]="'save'" [class]="'mr-25'"></span>Kaydet
        </button>
    </div>
</div>